export default "__VITE_ASSET__DlKb1HgV__"